import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  Stack,
  Button,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Typography,
  TableContainer,
  InputAdornment,
} from "@mui/material";

import "../../Style/pagestyle.scss";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import { GET_STUDENT_WITH_PAGINATION } from "../../Schema/Student";

import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import ViewImage from "../../Components/Student/ViewImage";
import SearchIcon from "@mui/icons-material/Search";
import CreateIcon from "../../Assets/create-icon.svg";
import CreateUser from "../../Components/User/CreateUser";
import LoadingPage from "./../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import moment from "moment";

export default function Enrollment() {
  // Change Language
  const { t } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  let pageStudent = window.localStorage.getItem("pageStudent");
  const { refetch } = useQuery(GET_STUDENT_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
    },
    onCompleted: ({ getStudentsWithPagination }) => {
      setTableData(getStudentsWithPagination?.data);
      setPaginationData(getStudentsWithPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, open, keyword]);

  useEffect(() => {
    setPage(parseInt(pageStudent || 1));
  }, [pageStudent]);

  const StudentSelectId = window.localStorage.getItem("ClickStudentId");

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              placeholder="Search"
              size="small"
              className="search-field"
              onChange={(e) => handleSearch(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={8} lg={9} xl={9.6}>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
              sx={{ width: "100%", height: "100%" }}
            >
              <Box>
                <Button
                  onClick={handleOpen}
                  className="btn-create"
                  startIcon={
                    <img
                      src={CreateIcon}
                      alt="CreateIcon"
                      className="icon-add"
                    />
                  }
                >
                  {t("create")}
                </Button>
              </Box>

              <CreateUser
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell className="header-title-start">N°</TableCell>
                <TableCell className="header-title">Name</TableCell>
                <TableCell className="header-title">Gender</TableCell>
                <TableCell className="header-title">Registration</TableCell>
                <TableCell className="header-title">Shift</TableCell>
                <TableCell className="header-title">Class</TableCell>
                <TableCell className="header-title">Student Type</TableCell>
                <TableCell className="header-title">Remark</TableCell>
                <TableCell className="header-title-end"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0|| tableData?.length === undefined  ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow
                          className={
                            StudentSelectId === row._id
                              ? "body-row onclick-student"
                              : "body-row"
                          }
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>

                          <TableCell className="body-cell">
                            <ViewImage
                              stuName={row?.lastName + " " + row?.firstName}
                              profileImg={row?.profileImg}
                            />
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.gender === "Male"
                              ? t("thead_male")
                              : t("thead_female")}
                          </TableCell>

                          <TableCell className="body-cell">
                            {moment().format("DD/MM/YYYY")}
                          </TableCell>

                          <TableCell className="body-cell">Morning</TableCell>

                          <TableCell className="body-cell">Beginner</TableCell>

                          <TableCell className="body-cell">សិស្សចាស់</TableCell>
                          <TableCell className="body-cell"></TableCell>
                          <TableCell className="body-cell-end"></TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
